import SliderComponent from '@pretto/bricks/components/utility/Slider'
import styled from 'styled-components'

export const Slider = styled(SliderComponent)`
  margin-top: 2px;
`
